import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography/Typography';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';


const TitleField = ({ classes, title, subtitle }) => (
  <div className={classes.titleCard}>
    <div className={classes.titleCardContent}>
      <Typography className={classes.headline} variant="h2">
        {title || <Skeleton />}
      </Typography>
      <Typography className={classes.subtitle} variant="h6">
        {subtitle || ''}
      </Typography>
    </div>
  </div>
);

TitleField.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.any,
  subtitle: PropTypes.any,
};

TitleField.defaultProps = {
  title: false,
  subtitle: false,
};

const styles = () => ({
  titleCard: {
    width: 'auto',
    paddingTop: '1.3rem',
    paddingBottom: '1.1rem',
  },
  titleCardContent: {
    margin: 'auto',
    maxWidth: '68.5rem',
  },
  headline: {
    fontSize: '1.5rem',
  },
  subtitle: {
    fontSize: '1.1rem',
    marginTop: '0.3rem',
  },
});

export default withStyles(styles)(withRouter(TitleField));
